import { Columns } from '../../../widgets/columns';
import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';

const Container = styled.div`
    padding: 20px;
    width: 100%;
    align-self: flex-start;
`;

const SkeletonCard = styled.div`
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.app.borderColor};
    overflow: hidden;
`;

const SkeletonPreview = styled.div`
    aspect-ratio: 1;
`;

const SkeletonInfo = styled.div`
    padding: 12px;
`;

export const AssetCardSkeleton: FC = () => {
    const theme = useTheme();

    return (
        <SkeletonCard>
            <SkeletonPreview>
                <ContentLoader
                    speed={2}
                    width='100%'
                    height='100%'
                    backgroundColor={theme.skeleton.backgroundColor}
                    foregroundColor={theme.skeleton.foregroundColor}
                >
                    <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
                </ContentLoader>
            </SkeletonPreview>
            <SkeletonInfo>
                <ContentLoader
                    speed={2}
                    width='100%'
                    height='40'
                    backgroundColor={theme.skeleton.backgroundColor}
                    foregroundColor={theme.skeleton.foregroundColor}
                >
                    {/* Asset name */}
                    <rect x='0' y='0' rx='4' ry='4' width='80%' height='14' />
                    {/* Metadata */}
                    <rect x='0' y='24' rx='4' ry='4' width='50%' height='12' />
                </ContentLoader>
            </SkeletonInfo>
        </SkeletonCard>
    );
};

export const AssetGridSkeleton: FC = () => {
    return (
        <Container>
            <Columns $xs={2} $md={3} $lg={8} $gap={20}>
                {Array.from({ length: 8 }).map((_, index) => (
                    <AssetCardSkeleton key={index} />
                ))}
            </Columns>
        </Container>
    );
};
